import { Component, Input } from '@angular/core';
import { ModalService } from '@bhtp-client-web/component';
import { Coverage } from './../../models/coverages/coverage.model';

@Component({
    selector: 'coverage-display',
    template: require('./coverage-display.component.html')
})
export class CoverageDisplayComponent {
    @Input() public coverage: Coverage;
    @Input() public mode: string;
    @Input() public isLastCoverage: boolean;

    constructor(private modalService: ModalService) { }

    public showDescription(): void {
        this.modalService.showMessageModal(this.coverage.name, this.coverage.description);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/components/coverages/coverage-display.component.ts